import axios from 'axios';
import { Industry } from '../../data_types';

const BASE_URL = process.env.REACT_APP_INDUSTRIES_BASE_URL as string;

if (!BASE_URL) {
    throw new Error('REACT_APP_INDUSTRIES_BASE_URL is not defined in the environment variables');
}

export const fetchIndustries = async (): Promise<{ industries: Industry[], industriesPerRow: number }> => {
    try {
        const response = await axios.get<{ industries: Industry[], industriesPerRow: number }>(BASE_URL, {
            withCredentials: true // Include credentials in the request
        });
        return response.data;
    } catch (error: any) {
        console.error('Failed to fetch industries:', error.message);
        throw new Error('Failed to fetch industries');
    }
};

export const addIndustry = async (newIndustry: Industry): Promise<Industry> => {
    try {
        const response = await axios.post<Industry>(BASE_URL, newIndustry, {
            withCredentials: true // Include credentials in the request
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to add industry');
    }
};
